import React from "react";
import axios from "axios";
import { Actions } from "../../components/actionsMenu/ActionsMenu";
import { RecordContextType } from "../../components/record/Record";
import { getStore } from "../../store/store";
import { Session } from "../../types/records.types";
import { PresenceDeclarationDocumentDialog } from "./actions-utils/PresenceDeclarationDocumentDialog";

type OnlyRecordContextItem = Pick<RecordContextType, "item"> & { item: Session };

export const actions: Actions = [
    {
        code: "generate_presence_statement_pdf",
        name: "Gerar/Enviar declaração de presença",
        actionFn: (context: OnlyRecordContextItem) => generatePresenceStatement(context),
    }
];

export const onlineSessionActions: Actions = [
    {
        code: "send_running_late_sms",
        name: "Avisar atraso (SMS)",
        actionFn: (context: OnlyRecordContextItem, _actionCode: string, user: any) => sendRunningLateSms(context, user),
    }
];

const generatePresenceStatement = async (context: OnlyRecordContextItem) => {
    const { appDialog } = getStore();

    appDialog.createDialog({
        title: "Declaração de Presença",
        contentAndActions: React.createElement(PresenceDeclarationDocumentDialog, {
            context: context,
            onClose: () => appDialog.toggleIsOpen(),
        }),

    });
    return {
        showSuccessMessage: "no",
    };

};

const sendRunningLateSms = async (context: OnlyRecordContextItem, user: any) => {
    const { notifications } = getStore();
    const session = context.item;

    const technicianFirstName = session?.technician?.user_id?.first_name ?? "";
    const technicianLastName = session?.technician?.user_id?.last_name ?? "";
    const technicianFullName = `${technicianFirstName} ${technicianLastName}`.trim();

    const clientPhone = (session as any)?.treatment?.client?.user_id?.phone ?? (session as any)?.lead?.phone;

    if (!clientPhone) {
        notifications.setNotification({
            isOpen: true,
            message: "Não foi possível encontrar o telefone do cliente",
            severity: "error",
        });
        return;
    }

    if (!technicianFullName) {
        notifications.setNotification({
            isOpen: true,
            message: "Não foi possível encontrar o nome do técnico",
            severity: "error",
        });
        return;
    }

    const smsMessage = `O(A) Dr(a). ${technicianFullName} esta a chegar. Pedimos desculpa pela espera e agradecemos a paciencia. Por favor nao desligue. NeuroImprove`

    try {
        await axios({
            method: "POST",
            url: "https://hook.eu1.make.com/6yi4p9jfxo7tveao1t650gtm3ggsqpsx",
            data: {
                type: "sms",
                content: smsMessage,
                id: (session as any)?.treatment?.id,
                entity: "treatments",
                phoneNumber: clientPhone,
                user_id: user?.id,
            },
        });

        notifications.setNotification({
            isOpen: true,
            message: "SMS de atraso enviado com sucesso",
            severity: "success",
        });

        return { showSuccessMessage: "no" };
    } catch (error: any) {
        const errorMessage = error?.response?.data?.errorMessage || "Erro ao enviar SMS";
        notifications.setNotification({
            isOpen: true,
            message: errorMessage,
            severity: "error",
        });
    }
};
